import React, { useMemo, useEffect } from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardHeader from "@mui/material/CardHeader";
import Grid from "@mui/material/Unstable_Grid2";
import { useSelector, useDispatch } from "react-redux";
import { MenuItemsForDropDown, IDType, TaxType } from "@soqs/common";
import CapacitySelector from "./CapacitySelector";
import SelectComponent from "./CustomComponents/SelectComponent";
import HalfColumn from "./CustomComponents/HalfColumn";
import {
  dropdownoptions,
  dropdownsloading
} from "../features/AppSlice";

const UserIdentificationComponent = () => {
  const dropdownopts = useSelector(dropdownoptions);
  const dropdownoptsloading = useSelector(dropdownsloading);


  return (
        <>
          <Grid item xs={12}>
            <Card>
              <CardContent>
                <CardHeader title="I'd like to see the Tax Return Status Dashboard for:" />
                <Grid container columnSpacing={1.5} rowSpacing={0.5}>
                  <Grid item xs={12} md={12}>
                    <CapacitySelector />
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
            <br />
            <Card>
              <CardContent>
                <CardHeader title="For the Tax Year:" />
                <HalfColumn>
                  <SelectComponent
                    label="Tax Year"
                    aria-label="Tax Year"
                    name="TaxYear"
                    required={true}
                    options={MenuItemsForDropDown(
                      "taxyear",
                      dropdownopts,
                      false
                    )}
                    optionsloading={dropdownoptsloading}
                  />
                </HalfColumn>
              </CardContent>
            </Card>
            <br />
          </Grid>
          <br />
        </>
  );
}

export default UserIdentificationComponent
